import {inject, Injectable} from '@angular/core';
import {SnackbarService} from "./snackbar.service";
import {MatSnackBarConfig} from "@angular/material/snack-bar";
import {HttpErrorResponse} from "@angular/common/http";
import {UserPreferencesService} from "./user-preferences.service";

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private snackbarService: SnackbarService = inject(SnackbarService);
  private userPreferencesService: UserPreferencesService = inject(UserPreferencesService);

  public handleError(error: HttpErrorResponse, customMessage?: string): void {
    const { message, status } = this.extractErrorDetails(error);
    const snackbarConfig = this.createSnackbarConfig();
    const formattedMessage = customMessage ? customMessage : this.formatErrorMessage(status, message);

    this.showSnackbar(formattedMessage, snackbarConfig);
    this.handleErrorFront(error);
  }

  public showErrorMessage(message: string): void {
    const snackbarConfig = this.createSnackbarConfig();

    this.showSnackbar(message, snackbarConfig);
  }

  private extractErrorDetails(error: HttpErrorResponse ): { message: string; status: number | string } {
    return {
      message: error.error.message || 'Неизвестная ошибка',
      status: error.status || 'Неизвестный код ошибки'
    };
  }

  private createSnackbarConfig(): MatSnackBarConfig  {
    return {
      duration: 10000
    };
  }

  private formatErrorMessage(status: number | string, message: string): string {
    const statusNum = typeof status === 'string' ? parseInt(status, 10) : status;
    const formatMap: Record<string, (msg: string, status: number | string) => string> = {
      '4xx': (msg) => `Ошибка: ${msg}`,
      '5xx': (msg) => `Ошибка сервера: ${msg}`,
      'default': (msg, stat) => `Ошибка: ${stat}: ${msg}`
    };

    const key = Number.isFinite(statusNum) && statusNum >= 400 && statusNum < 500 ? '4xx' :
      Number.isFinite(statusNum) && statusNum >= 500 && statusNum < 600 ? '5xx' : 'default';

    return formatMap[key](message, status);
  }

  private showSnackbar(message: string, config: MatSnackBarConfig): void {
    this.snackbarService.showMessage({
      type: 'error',
      message: message,
      config: config
    });
  }

  private handleErrorFront({ error }: HttpErrorResponse): void {
    if (!error.frontendErrorType) { return; }

    switch (error.frontendErrorType) {
      case 'PROPERTY_REFERENCE':
        this.userPreferencesService.resetPreferencesToDefault();
        break;
      default:
        break;
    }
  }
}
